import { ContactFormBlockProps } from './contact-form-block/contact-form-block';
import { FullWidthBannerProps } from './editorial-full-width-banner-block/editorial-full-width-banner-block';
import { FullWidthCarouselProps } from './editorial-full-width-carousel-block/editorial-full-width-carousel-block';
import { FullWidthColumnProps } from './editorial-full-width-column-block/editorial-full-width-column-block';
import { FullWidthImageMosaicProps } from './editorial-full-width-image-mosaic-block/editorial-full-width-image-mosaic-block';
import { FullWidthTextAndImageProps } from './editorial-full-width-text-and-image-block/editorial-full-width-text-and-image-block';
import { BlockGiftCardOnlineWebShopProps } from './gift-card-block/gift-card-block';
import { IframeModalBlockProps } from './iframe-modal-block/iframe-modal-block';
import { MainBannerListBlockProps } from './main-banner-list-block/main-banner-list-block';
import { MeetingPlaceOpeningHoursBlockProps } from './meeting-place-opening-hours-block/meeting-place-opening-hours-block';
import { RichTextBlockProps } from './render-blocks/rich-text-block/rich-text-block';
import { TenantOpeningHoursBlockProps } from './tenant-opening-hours-block/tenant-opening-hours-block';
import { TextAndImageCardBlockProps } from './text-and-image-card-block/text-and-image-card-block';
// /*
//  Export them with alias same as in Contentful. Is either this way, or create a field on each block with the name 'blocktype',
//  that has a default value that can't be changed (if that is possible)
//  Now I use an alias in the GraphQL query, `blocktype: __typename`, in order to automatically map Contentful blocks with components.
//  Theoretically, one should be able to drop in the <RenderBlocks/> component on any page with blocks and everything should resolve.
//  Then, there is the issue of Typing...
// */
export { default as BlockTextAndImageCard } from './text-and-image-card-block/text-and-image-card-block';
export { default as BlockGiftCard } from './gift-card-block/gift-card-block';
export { default as BlockContactform } from './contact-form-block/contact-form-block';
export { default as BlockRichText } from './render-blocks/rich-text-block/rich-text-block';
export { default as LibraryMeetingPlaceMainBannerList } from './main-banner-list-block/main-banner-list-block';
export { default as BlockMeetingPlaceOpeningHours } from './meeting-place-opening-hours-block/meeting-place-opening-hours-block';
export { default as BlockTenantOpeningHours } from './tenant-opening-hours-block/tenant-opening-hours-block';
export { default as BlockEditorialFullWidthBanner } from './editorial-full-width-banner-block/editorial-full-width-banner-block';
export { default as BlockEditorialFullWidthImageAndText } from './editorial-full-width-text-and-image-block/editorial-full-width-text-and-image-block';
export { default as BlockEditorialFullWidthImageMosaic } from './editorial-full-width-image-mosaic-block/editorial-full-width-image-mosaic-block';
export { default as BlockEditorialFullWidthColumn } from './editorial-full-width-column-block/editorial-full-width-column-block';
export { default as BlockEditorialFullWidthCarousel } from './editorial-full-width-carousel-block/editorial-full-width-carousel-block';
export { default as BlockIframeModal } from './iframe-modal-block/iframe-modal-block';

export type BlockSectionProps =
  | TextAndImageCardBlockProps
  | ContactFormBlockProps
  | MainBannerListBlockProps
  | RichTextBlockProps
  | MeetingPlaceOpeningHoursBlockProps
  | TenantOpeningHoursBlockProps
  | BlockGiftCardOnlineWebShopProps
  | FullWidthBannerProps
  | FullWidthTextAndImageProps
  | FullWidthImageMosaicProps
  | FullWidthColumnProps
  | FullWidthCarouselProps
  | IframeModalBlockProps;

type BlockTypes =
  | 'BlockTextAndImageCard'
  | 'BlockContactform'
  | 'BlockMainBanner'
  | 'RichText'
  | 'LibraryMeetingPlaceMainBannerList'
  | 'BlockMeetingPlaceOpeningHours'
  | 'BlockTenantOpeningHours'
  | 'BlockGiftCard'
  | 'BlockEditorialFullWidthBanner'
  | 'BlockEditorialFullWidthImageAndText'
  | 'BlockEditorialFullWidthImageMosaic'
  | 'BlockEditorialFullWidthColumn'
  | 'BlockEditorialFullWidthCarousel'
  | 'BlockIframeModal';

type WithBlockType<B = BlockTypes, P = BlockSectionProps> = {
  id: string;
  blocktype: B;
} & P;

export type BlockSections =
  | WithBlockType<'BlockTextAndImageCard', TextAndImageCardBlockProps>
  | WithBlockType<'BlockGiftCard', BlockGiftCardOnlineWebShopProps>
  | WithBlockType<'BlockContactform', ContactFormBlockProps>
  | WithBlockType<'BlockRichText', RichTextBlockProps>
  | WithBlockType<'BlockGiftCardOnlineWebShop', BlockGiftCardOnlineWebShopProps>
  | WithBlockType<'LibraryMeetingPlaceMainBannerList', MainBannerListBlockProps>
  | WithBlockType<
      'BlockMeetingPlaceOpeningHours',
      MeetingPlaceOpeningHoursBlockProps
    >
  | WithBlockType<'BlockTenantOpeningHours', TenantOpeningHoursBlockProps>
  | WithBlockType<'BlockEditorialFullWidthBanner', FullWidthBannerProps>
  | WithBlockType<
      'BlockEditorialFullWidthImageAndText',
      FullWidthTextAndImageProps
    >
  | WithBlockType<
      'BlockEditorialFullWidthImageMosaic',
      FullWidthImageMosaicProps
    >
  | WithBlockType<'BlockEditorialFullWidthColumn', FullWidthColumnProps>
  | WithBlockType<'BlockEditorialFullWidthCarousel', FullWidthCarouselProps>
  | WithBlockType<'BlockIframeModal', IframeModalBlockProps>;
